module.exports = __webpack_public_path__ + "static/media/homestay_taiwan.5935d7e0.webp";